import {Injectable} from '@angular/core';
import {Http, RequestOptions, Headers, Response} from "@angular/http";
import {Observable, Subscriber} from "rxjs";
import {Utils} from "../http/utils";
import {OAuthToken} from "../../models/oauthtoken";
import {UserStorageService} from "./user-storage.service";
import {Config} from "../../../../environments/environment";


@Injectable()
export class AuthenticationService {

  private refreshTokenTimer: Observable<number> = null;

  constructor(protected http: Http,
              protected userStorage: UserStorageService) {
    this.userStorage.token$.subscribe(token => this.registerRefresher(token))
  }

  private tokenIsExpired(token: OAuthToken) {
    let timeout = (token.expires_in - 60 * 5)*1000;
    let refreshStart = token.refresh_date.valueOf() + timeout - new Date().valueOf();
    return refreshStart < 0;
  }

  private registerRefresher(token: OAuthToken) {
    if (token != null) {
      let timeout = (token.expires_in - 60 * 5)*1000;
      let refreshStart = token.refresh_date.valueOf() + timeout - new Date().valueOf();
      refreshStart = Math.max(30 * 1000, refreshStart);
      this.refreshTokenTimer = Observable.timer(refreshStart, timeout);
      this.refreshTokenTimer.subscribe((token) => {
        this.refreshAccessToken(this.userStorage.oauthToken.refresh_token).subscribe(() => null);
      });
    }
  }

  private buildBaseRequestParams() {
    return {
      "client_id": Config.clientId,
      "client_secret": Config.clientSecret,
    };
  }

  private buildRequestOptions() {
    return new RequestOptions({
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded"
      })
    });
  }


  public login(email: string, password: string, remember: boolean): Observable<boolean> {
    let oauthRequestParams = this.buildBaseRequestParams();
    oauthRequestParams["grant_type"] = Config.grantTypePassword;
    oauthRequestParams["username"] = email;
    oauthRequestParams["password"] = password;
    let options = this.buildRequestOptions();

    return new Observable<boolean>((subscriber: Subscriber<boolean>) => {
      this.http.post(Config.authUrl, Utils.toUrlString(oauthRequestParams), options).subscribe(
        response => {
          let oauthToken: OAuthToken = response.json();
          this.userStorage.storeToken(oauthToken, remember);
          subscriber.next(true);
          subscriber.complete();
        },
        error => {
          if (error.status == 0) {
            subscriber.error({
              error_description: "Server failed to responsd"
            })
          } else {
            subscriber.error(error.json());
          }
        }
      )
    });
  }

  public refreshAccessToken(refreshToken: string): Observable<OAuthToken> {
    let oauthRequestParams = this.buildBaseRequestParams();
    oauthRequestParams["grant_type"] = Config.grantTypeRefresh;
    oauthRequestParams["refresh_token"] = refreshToken;
    let options = this.buildRequestOptions();

    return this.http.post(Config.authUrl, Utils.toUrlString(oauthRequestParams), options)
      .map((response: Response) => (<OAuthToken>response.json()))
      .catch(error => {
        this.userStorage.clearToken();
        return Observable.throw(error);
      })
      .do(token => this.userStorage.updateToken(token));
  }

  public isAuthenticated(): Observable<boolean> {
    return this.userStorage.token$.mergeMap((token: OAuthToken) => {
      if (token == null) {
        return Observable.from([false]);
      }
      if (this.tokenIsExpired(token)) {
        return this.refreshAccessToken(token.refresh_token).map(() => true).catch(err => Observable.from([false]));
      } else {
        return Observable.from([true])
      }
    }).first();
  }

  logout() {
    this.userStorage.clearToken();
  }
}




// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/services/authentication/authentication.service.ts